<script lang="ts">
  import { onMount } from 'svelte'
  import Navbar from '@/components/appDriver/Navbar.svelte'
  import { currentPage, topupPaymentGatewayResult } from '@/components/appDriver/store'
  import PageTopupChannel from '@/components/appDriver/topup/PageTopupChannel.svelte'
  import PaymentJDB from '@/components/appDriver/topup/PaymentJDB.svelte'
  import PaymentOnePay from '@/components/appDriver/topup/PaymentOnePay.svelte'
  import Swal from 'sweetalert2'
  import PaymentGLN from '@/components/appDriver/topup/PaymentGLN.svelte'
  import PaymentAlipay from '@/components/appDriver/topup/PaymentAlipay.svelte'
  import PaymentLDB from '@/components/appDriver/topup/PaymentLDB.svelte'
  import PaymentLocaPay from '@/components/appDriver/topup/PaymentLocaPay.svelte'
  import PaymentThaiQr from '@/components/appDriver/topup/PaymentThaiQr.svelte'
  import PaymentUMoney from '@/components/appDriver/topup/PaymentUMoney.svelte'
  import PaymentMMoney from '@/components/appDriver/topup/PaymentMMoney.svelte'
  import PaymentWechat from '@/components/appDriver/topup/PaymentWechat.svelte'
  import PaymentUnionPay from '@/components/appDriver/topup/PaymentUnionPay.svelte'

  onMount(() => {
    $currentPage = 'topup-qr'
  })

  async function onBack() {
    let message =  'ທ່ານແນ່ໃຈບໍ່ທີ່ຈະກົດຍົກເລີກ, ການຊຳລະນີ້ຈະບໍ່ສາມາດບັນທຶກໄດ້ ຖ້າທ່ານຍົກເລີກ'

    if ($topupPaymentGatewayResult?.channel === 'alipay')
      message = 'ລາຍການນີ້ຍັງບໍ່ທັນຊຳລະ ກົດປຸ່ມກວດສອບກ່ອນ.<br>ທ່ານຕ້ອງການຢືນຢັນການອອກຈາກໜ້ານີ້ບໍ່?';

    const swalResult = await Swal.fire({
      icon: 'question',
      html: message,
      showCancelButton: true,
      confirmButtonText: 'ຢືນຢັນ',
      cancelButtonText: 'ຍົກເລີກ',
      confirmButtonColor: '#B61E20',
    })

    if (!swalResult.isConfirmed) {
      return
    }

    PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupChannel })
  }
</script>

<div class="page flex flex-col h-full bg-[#EFEFEF]">

  <Navbar showBack={true} on:back={onBack}/>

  {#if ($topupPaymentGatewayResult?.channel === 'onepay')}

    <PaymentOnePay/>

  {:else if ($topupPaymentGatewayResult?.channel === 'gln')}

    <PaymentGLN/>

  {:else if ($topupPaymentGatewayResult?.channel === 'jdb')}

    <PaymentJDB/>

  {:else if ($topupPaymentGatewayResult?.channel === 'locapay')}

    <PaymentLocaPay/>

  {:else if ($topupPaymentGatewayResult?.channel === 'alipay')}

    <PaymentAlipay/>

  {:else if ($topupPaymentGatewayResult?.channel === 'ldb')}

    <PaymentLDB/>

  {:else if ($topupPaymentGatewayResult?.channel === 'thaiqr')}

    <PaymentThaiQr/>

  {:else if ($topupPaymentGatewayResult?.channel === 'umoney')}

    <PaymentUMoney/>

  {:else if ($topupPaymentGatewayResult?.channel === 'mmoney')}

    <PaymentMMoney/>

  {:else if ($topupPaymentGatewayResult?.channel === 'wechat')}

    <PaymentWechat/>

  {:else if ($topupPaymentGatewayResult?.channel === 'unionpay')}

    <PaymentUnionPay/>

  {/if}

</div>
